import styled from '@emotion/styled';
import { useContextTranslation } from '@core/i18n';
import { BADGE_TYPE } from './constants';
const Label = styled('span') `
  display: inline-block;
  padding: 3px 9px;
  border-radius: 4px;
`;
const SponsoredLabel = styled(Label) `
  background: var(--ad-badge-background, transparent);
  color: var(--ad-badge-font-color, inherit);
`;
/**
 * Sponsored/Featured text badge component.
 */
export const SponsoredText = ({ video, hide }) => {
    const { t } = useContextTranslation();
    const isSponsored = video?.badge === BADGE_TYPE.AD;
    const isFeatured = video?.badge === BADGE_TYPE.FEATURED;
    // Add <span> around translated texts to work around #1813
    // https://github.com/facebook/react/issues/11538.
    return isSponsored && !hide ? (<SponsoredLabel className="cy-sponsored">{t('Sponsored')}</SponsoredLabel>) : isFeatured ? (<Label>{t('Featured')}</Label>) : null;
};
